
import Filters from './util/Filter';

jQuery(document).ready(() => {
  new Filters({
    url: smg_global.ajaxurl,
    nonce: smg_global.ajaxnonce,
    action: smg_product_filter.action,
    parent: smg_product_filter.parent,
    term_id: smg_product_filter.term_id,
    maxItems: smg_product_filter.maxItems,
  });

  jQuery(document).on('click', 'div#simple a', function (e) {
    e.preventDefault();
    jQuery(this).toggle('slow');
    jQuery(this).offsetParent().find('#variable').toggle('slow');
  });

  /**
   * @author Marcos Robles
   * add to cart ajax way
   */

  jQuery(document).on(
    'click',
    'a.button.product_type_simple.add_to_cart_button',
    function (e) {
      e.preventDefault();
      var self = $(this),
        product_id = self.attr('data-product_id'),
        parent_id = self.attr('parent_id'),
        progress_bar = $('.progress-bar[product_id="' + parent_id + '"]'),
        progress_bar_filled = $(
          '.progress-bar[product_id="' + parent_id + '"] .fill'
        ),
        button_view_cart = $('.v-cart[pid="' + parent_id + '"]');

      if (self.hasClass('rss_ajax_add_to_cart')) {
        (progress_bar = $('.progress-bar[product_id="' + product_id + '"]')),
          (progress_bar_filled = $(
            '.progress-bar[product_id="' + product_id + '"] .fill'
          ));
        button_view_cart = $('.v-cart[pid="' + product_id + '"]');
      }

      progress_bar.fadeIn();
      $.ajax({
        type: 'POST',
        url: smg_global.ajaxurl,
        data: {
          action: 'smg_global_action',
          process: 'add_to_cart_shop',
          product_id: product_id,
        },
        beforeSend: function () {
          progress_bar_filled.animate({
            width: '50%',
          });
          $('.v-cart').hide();
        },
        success: function (data) {
          console.log(data);
          if(data.response == '200') {
            $('.msg-added-to-cart .msgd').html(data.name + ' has been added to your cart.')
            $('.msg-added-to-cart').css('visibility', 'visible')
            
            
            progress_bar_filled.animate({
              width: '100%',
            });
            setTimeout(function () {
              progress_bar.fadeOut();
              progress_bar_filled.css('width', '0');
              //Sumar item en header.
              var number = $('input#number_item').val();
              var add = (parseInt(number) + parseInt(1));
              $('li.bag span.number').text(add);
              $('input#number_item').val(add);
            }, 1000);

            setTimeout(function () {
              button_view_cart.fadeIn();
            }, 1500);

            setTimeout(function () {
              button_view_cart.fadeOut();
              $('.msg-added-to-cart').css('visibility', 'hidden')
              
            }, 10000);

          } else if(data.response == '300') {
            $('.msg-added-to-cart .msgd').addClass('error').html(data.msg)
            $('.msg-added-to-cart').css('visibility', 'visible')

            progress_bar_filled.animate({
              width: '100%',
            });
            setTimeout(function () {
              progress_bar.fadeOut();
              progress_bar_filled.css('width', '0');
            }, 1000);

            setTimeout(function () {
              button_view_cart.fadeIn();
            }, 1500);

            setTimeout(function () {
              button_view_cart.fadeOut();
              $('.msg-added-to-cart').css('visibility', 'hidden')
              $('.msg-added-to-cart .msgd').removeClass('error').html('')
            }, 10000);
          }
        },
      });
    }
  );

  //new class
  if($('body').hasClass('post-type-archive-product')) {
    $('.overlay-ms').fadeIn();
    $('.modal-consignment-shop').css('display', 'flex');
  }

  jQuery(document).on('click', '.modal-consignment-shop button.btn-save', function(e) {
    e.preventDefault();
    var self = $(this),
    select = $('select.smg_selector_consignment'),
    consignment_val = select.val();

    //console.log('##' + consignment_val);
    console.log('Demo' + consignment_val + ''+ smg_global.ajaxurl);
    if(consignment_val) {
      $.ajax({
        type: 'POST',
        url: smg_global.ajaxurl,
        data: {
          action: 'smg_global_action',
          process: 'consignment_process_shop',
          consignment: consignment_val,
          
        },
        beforeSend: function() {
          self.attr('disabled', true);
        },
        success: function(data) {
          console.log(data)
          $('.overlay-ms').hide();
          $('.modal-consignment-shop').hide();
          self.removeAttr('disabled');
        },
        error: function(error) {
          console.log(error);
        },
      });
    }
  });

  jQuery(document).on('click', '.modal-consignment-shop .modal-action', function(e) {
    e.preventDefault();
    $('.overlay-ms').hide();
    $('.modal-consignment-shop').hide();
  });

  $(document).on('click', '.v-cart a', function(e) {
    e.preventDefault()
    var self = $(this),
    url = self.attr('href')
    window.location.href = url
  })
});
